import { Link } from "react-router-dom";
import { CommonFormPropsType } from "../../../types/other-pages/OtherPages";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";


const CommonLogo = ({ alignLogo }: CommonFormPropsType) => {
  return (
    <Link
      className={`logo ${alignLogo ? alignLogo : ""}`}
      to={`${process.env.PUBLIC_URL}/dashboard`}
    >
      <Image
        className="img-fluid for-dark"
        src={dynamicImage("dashboard-8/Linnk_Group_logo.png")}
        alt="loginpage"
        style={{ width: "200px", height: "auto" }}
      />
      <Image
        className="img-fluid for-light"
        src={dynamicImage("dashboard-8/Linnk_Group_logo.png")}
        alt="loginpage"
        style={{ width: "200px", height: "auto" }}
      />
    </Link>
  );
};

export default CommonLogo;
